import { appHttpClient } from "../../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../../installations/http/inFlight";

export const addAttribute = (data) => {
    return appHttpClient.post(`/Attribute/Add`, data);
};

export const updateAttribute = (data) => {
    return appHttpClient.post(`/Attribute/Update`, data);
};

export const deleteAttribute = (attributeId) => {
    return appHttpClient.delete(`/Attribute/Delete/${attributeId}`);
};

export const getAttributeById = (attributeId) => {
    // 0016: dedupe StrictMode double-invoke; key on the id so different attributes fetch independently.
    return dedupeRequest(`attribute:${attributeId}`, () =>
        appHttpClient.get(`/Attribute/${attributeId}`)
    );
};

export const getAttributes = (queryParams) => {
    // 0016: dedupe StrictMode double-invoke; key on the params so different queries fetch independently.
    return dedupeRequest(`attributes:${JSON.stringify(queryParams || {})}`, () =>
        appHttpClient.get(`/Attribute/GetAttributes`, { params: queryParams })
    );
};

export const addAttributeValue = (data) => {
    return appHttpClient.post(`/Attribute/AddValue`, data);
};

export const updateAttributeValue = (data) => {
    return appHttpClient.post(`/Attribute/UpdateValue`, data);
};

export const deleteAttributeValue = (valueId) => {
    return appHttpClient.delete(`/Attribute/DeleteValue/${valueId}`);
};

export const getAttributeValues = (attributeId) => {
    // 0016: dedupe StrictMode double-invoke; key on the id so different attributes fetch independently.
    return dedupeRequest(`attributeValues:${attributeId}`, () =>
        appHttpClient.get(`/Attribute/Values/${attributeId}`)
    );
};

const attributeService = {
    addAttribute,
    updateAttribute,
    deleteAttribute,
    getAttributeById,
    getAttributes,
    addAttributeValue,
    updateAttributeValue,
    deleteAttributeValue,
    getAttributeValues,
};

export default attributeService;
